import React from 'react';
import gql from 'graphql-tag';

import { RCStarRating } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { SHOP_PATH } from '@reverbdotcom/commons/src/url_helpers';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

import {
  Item2ShopOverviewData,
} from '../schemas/rql';

interface IProps {
  listing: Item2ShopOverviewData.Fragment;
}

export const Item2ShopOverviewFragment = gql`
  fragment Item2ShopOverviewData on Listing {
    _id
    seller {
      _id
      feedbackSummary {
        rollingRatingPercentage
        receivedCount
      }
    }
    shop {
      _id
      name
      slug
      address {
        displayLocation
        countryCode
      }
    }
  }
`;

export function Item2ShopOverview(props: IProps) {
  const { listing } = props;
  const { shop, seller } = listing;

  if (!shop) return null;

  return (
    <div className="item2-shop-overview">
      <div className="item2-shop-overview__title">
        <CoreLink
          to={SHOP_PATH.expand({ slug: shop.slug })}
          className="weight-bold lh-130 hyphenate color-gray mr-1"
          clickEvent={{
            eventName: MParticleEventName.ClickedComponent,
            componentName: 'Item2ShopOverview',
            entityType: 'url',
            entityId: SHOP_PATH.expand({ slug: shop.slug }),
          }}
        >
          {shop.name}
        </CoreLink>
        {seller?.feedbackSummary?.receivedCount > 0 &&
          <RCStarRating
            rating={seller?.feedbackSummary?.rollingRatingPercentage / 100}
          />
        }
      </div>
      <div className="item2-shop-overview__location">
        {shop.address?.displayLocation}
      </div>
    </div>
  );
}
